module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/rule_frame-05418653e0639580d7e29d1de4a5af64.svg";